{
  "es": {
    "snippets": {
      "labels": {
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "create": "Crear un fragmento",
        "delete": "Eliminar",
        "edit": "Editar",
        "editTitle": "Editar fragmento",
        "initMessage": "Selecciona un fragmento para previsualizarlo aquí.",
        "language": "Idioma",
        "linkable": "Tipo",
        "linkableClient": "Equipo",
        "linkableEmployee": "Personal",
        "linkablePartner": "Colaborador",
        "manage": "Gestiona tus fragmentos",
        "manageMessage": "O haz clic aquí para gestionar todos tus fragmentos en la configuración de la organización",
        "message": "Mensaje",
        "messageError": "Introduce un mensaje",
        "new": "Nuevo fragmento",
        "noSnippets": "Aún no tienes fragmentos.",
        "preview": "Vista previa",
        "save": "Guardar",
        "search": "Buscar",
        "select": "Seleccionar",
        "snippets": "Fragmentos",
        "title": "Título",
        "titleError": "Introduce un título"
      }
    }
  }
}
